webpackJsonp([16],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	__webpack_require__(2);
	__webpack_require__(3);
	__webpack_require__(4);
	
	__webpack_require__(21);
	__webpack_require__(12);
	__webpack_require__(7);
	__webpack_require__(6);
	__webpack_require__(118);

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	
		var afterExpandCollapseFns = [];
		window.afterExpandCollapse = function (fn) {
			afterExpandCollapseFns.push(fn);
		};
		var leftWidth = 250;
		var rightWidth = 270;
		window.collapse = function (side) {
			$('#route_container').css('background', '#FFF');
			var col = $('.fullpage_' + side + '_col');
			if (side == 'left') {
				leftWidth = $('.fullpage_left_col').outerWidth();
				$('#map,#central').animate({ marginLeft: 0 }, 50, function () {
					$('#route_container').css('background', '#333');
					_.each(afterExpandCollapseFns, function (fn) {
						fn();
					});
				});
			}
			if (side == 'right') {
				rightWidth = $('.fullpage_right_col').outerWidth();
				$('#map,#central').animate({ marginRight: 0 }, 50, function () {
					_.each(afterExpandCollapseFns, function (fn) {
						fn();
					});
				});
			}
			col.children('.collapse').removeClass('collapse').addClass('expand');
			var toAnimate;
			if (side === 'left') toAnimate = { left: -col.outerWidth() };else toAnimate = { width: 0 };
			col.animate(toAnimate, 50, function () {
				col.addClass('hidden_' + side + '_col');
			});
			col.children('#ds_v, #ds_vl').hide();
			return false;
		};
		window.expand = function (side) {
			var col = $('.fullpage_' + side + '_col');
			var width = leftWidth + 'px';
			col.children('.expand').addClass('collapse').removeClass('expand');
			if (side == 'left') {
				$('.fullpage_left_col a.left').show();
				$('#map,#central').animate({ marginLeft: leftWidth }, 50, function () {
					col.children('#ds_v, #ds_vl').show();
					_.each(afterExpandCollapseFns, function (fn) {
						fn();
					});
				});
			}
			if (side == 'right') {
				$('#map,#central').animate({ marginRight: rightWidth }, 50, function () {
					col.children('#ds_v, #ds_vl').show();
					_.each(afterExpandCollapseFns, function (fn) {
						fn();
					});
				});
				width = rightWidth + 'px';
			}
			var toAnimate;
			if (side === 'left') toAnimate = { left: 0 };else toAnimate = { width: width };
			col.animate(toAnimate, 50, function () {
				col.removeClass('hidden_' + side + '_col');
			});
			return false;
		};
		window.toggleSidebars = function (side) {
			var col = $('.fullpage_' + side + '_col');
			var hidden_class_name = 'hidden_' + side + '_col';
			if (col.hasClass(hidden_class_name)) {
				window.expand(side);
			} else {
				window.collapse(side);
			}
		};
	})();
	$(function () {
		// cant have the left side resizable without doing something smarter.  upgrading to jquery 1.4 made the resizable ui plugin set the left bar as relative, not absolute, which forces the map to flow below.
		//$('.fullpage_left_col').resizable({handles: 'e', maxWidth: 500, minWidth: 240, resize: function(event, ui) {
		//$('#map').css('margin-left', ui.helper.width());
		//}
		//});
	
		$('.contracted').next('div').hide();
	
		$(document).on("click", '.left.collapse', function () {
			collapse('left');
			Application.setPreference('route_planner_left_sidebar_closed', true, true);
			return false;
		});
		$(document).on("click", '.right.collapse', function () {
			collapse('right');
			Application.setPreference('route_planner_right_sidebar_closed', true, true);
			return false;
		});
		$(document).on("click", '.expand.left', function () {
			expand('left');
			Application.setPreference('route_planner_left_sidebar_closed', false, true);
			return false;
		});
		$(document).on("click", '.expand.right', function () {
			expand('right');
			Application.setPreference('route_planner_right_sidebar_closed', false, true);
			return false;
		});
	
		$('.toggle_next').click(function () {
			var $next = $(this).next();
			//the toggle element can be wrapped in a tooltip and still work
			if ($next.length == 0) $next = $(this).parent().next();
			$(this).toggleClass('contracted');
			$next.slideToggle(400);
		});
	});

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

	'use strict';
	
	rwgps.ns('segments.show', function () {
	  var ns = this,
	      Segment,
	      SegmentMatch,
	      SegmentMatches,
	      SegmentView,
	      SegmentMatchView,
	      CommentsView,
	      CommentView,
	      Comment,
	      Comments,
	      CompareEffortsView,
	      CompareEffortsRowView;
	
	  Segment = rwgps.ns('models').Segment = Backbone.Model.extend({
	    initialize: function initialize() {
	      // parse comments now
	      var parsedComments = _.map(this.get('comments'), Comment.prototype.parse);
	      this.userHasComments = _.reduce(parsedComments, function (m, c) {
	        m[c.user_id] = true;
	        return m;
	      }, {});
	
	      this.comments = new Comments(parsedComments);
	      _.each(this.comments.models, function (comment) {
	        comment.segment = this;
	      }, this);
	    },
	
	    ignore: function ignore() {
	      $.post('/segments/' + this.get('_id') + '/ignore');
	      this.set('is_ignored', true);
	      this.set('ignored_count', this.get('ignored_count') + 1);
	    },
	    remember: function remember() {
	      $.post('/segments/' + this.get('_id') + '/remember');
	      this.set('is_remembered', true);
	      this.set('remembered_count', this.get('remembered_count') + 1);
	    },
	    unignore: function unignore() {
	      $.post('/segments/' + this.get('_id') + '/unignore');
	      window.asdf = this;
	      this.set('is_ignored', false);
	      this.set('ignored_count', this.get('ignored_count') - 1);
	    },
	    unremember: function unremember() {
	      $.post('/segments/' + this.get('_id') + '/unremember');
	      this.set('is_remembered', false);
	      this.set('remembered_count', this.get('remembered_count') - 1);
	    },
	    flag: function flag() {
	      $.post("/segments/" + this.get("_id") + "/flag");
	      $.jGrowl("Flagged! We'll check it out, thanks for the help.");
	    }
	  });
	
	  SegmentMatch = rwgps.ns('models').SegmentMatch = Backbone.Model.extend({
	    route: function route() {
	      if (this.pointsDfd) return this.pointsDfd.promise();
	      var match = this,
	          dfd = this.pointsDfd = new $.Deferred();
	      $.getJSON('/segment_matches/' + this.get('_id') + '.json', function (data) {
	        if (data) {
	          var route = new rwgps.Route({ track_points: data.points });
	          match.set('data', new rwgps.Data(route.trackPoints()));
	          dfd.resolve(route);
	        } else {
	          dfd.reject();
	        }
	      });
	      return dfd.promise();
	    },
	    fullTrip: function fullTrip() {
	      if (this.tripDfd) return this.tripDfd.promise();
	      var dfd = this.tripDfd = new $.Deferred();
	      $.getJSON('/trips/' + this.get('parent_id') + '.json', function (data) {
	        if (data && data.track_points.length > 0) {
	          var route = new rwgps.Route(data);
	          dfd.resolve(route);
	        } else {
	          dfd.reject();
	        }
	      });
	      return dfd.promise();
	    },
	    parse: function parse(data) {
	      if (data.departed_at) {
	        data.departed_at = rwgps.DateExt.parse(data.departed_at);
	      }
	      if (data.started_at) {
	        data.started_at = rwgps.DateExt.parse(data.started_at, true);
	      }
	      data.final_time_field = ns.segmentJson.final_time_field;
	      return data;
	    },
	    flag: function flag() {
	      $.post("/segment_matches/" + this.get("_id") + "/flag");
	      $.jGrowl("Flagged! We'll check it out, thanks for the help.");
	    },
	    flagRemove: function flagRemove() {
	      $.post("/segment_matches/" + this.get("_id") + "/flag_remove");
	      $.jGrowl("Match marked as flag-removed.");
	    }
	  });
	  SegmentMatches = rwgps.ns('collections').SegmentMatches = Backbone.Collection.extend({
	    model: SegmentMatch,
	    rankComparator: function rankComparator(a, b) {
	      var diff = a.get('final_time') - b.get('final_time');
	      if (diff == 0) {
	        diff = a.get('user_as_json').id - b.get('user_as_json').id;
	      }
	      return diff;
	    },
	
	    dateComparator: function dateComparator(a, b) {
	      return b.get('started_at') - a.get('started_at');
	    },
	    filterByUser: function filterByUser(userId) {
	      return this.filter(function (match) {
	        return match.get('user_as_json').id == userId;
	      });
	    },
	    filterByUniqueUser: function filterByUniqueUser() {
	      var userIdCache = {};
	      return this.filter(function (match) {
	        if (userIdCache[match.get('user_as_json').id]) return false;else {
	          userIdCache[match.get('user_as_json').id] = true;
	          return true;
	        }
	      });
	    }
	  });
	  SegmentMatches.prototype.comparator = SegmentMatches.prototype.rankComparator;
	
	  Comment = Backbone.Model.extend({
	    parse: function parse(data) {
	      data.created_at = rwgps.DateExt.parse(data.created_at);
	      return data;
	    },
	    deleteBody: function deleteBody() {
	      var _this = this;
	
	      $.post('/segments/' + this.segment.get('_id') + '/delete_comment/' + this.get('id'), function () {
	        _this.collection.remove(_this);
	      });
	    }
	  });
	
	  Comments = Backbone.Collection.extend({
	    model: Comment,
	    dateDescComparator: function dateDescComparator(a, b) {
	      return b.get('created_at') - a.get('created_at');
	    },
	    dateAscComparator: function dateAscComparator(b, a) {
	      return b.get('created_at') - a.get('created_at');
	    }
	  });
	  Comments.prototype.comparator = Comments.prototype.dateAscComparator;
	
	  CommentView = Backbone.View.extend({
	    className: 'comment',
	    template: _.template($('#commentTemplate').html()),
	    initialize: function initialize() {
	      _.bindAll(this, 'highlight', 'render');
	      this.model.bind('change', this.render);
	      this.options.commentsView.bind('user:highlight_comments:' + this.model.get('user_id'), this.highlight);
	    },
	    events: {
	      'click a.remove': 'destroy'
	    },
	    highlight: function highlight() {
	      if (!this.$el.hasClass('highlighted')) this.$el.addClass('highlighted');
	    },
	    render: function render() {
	      var data = this.model.toJSON();
	      data.user = ns.usersMap[data.user_id];
	      data.currentUserId = rwgps.config.currentUser ? rwgps.config.currentUser.id : 0;
	      data.deleted = data.deleted;
	      this.$el.html(this.template(data));
	      return this;
	    },
	    destroy: function destroy() {
	      var _this2 = this;
	
	      customConfirm('Sure you want to delete your comment?', function () {
	        _this2.model.deleteBody();
	      });
	    }
	  });
	
	  CommentsView = Backbone.View.extend({
	    el: '#segments-show .comments-container',
	    initialize: function initialize() {
	      _.bindAll(this, 'render');
	      this.model.comments.bind('add', this.render);
	      this.model.comments.bind('remove', this.render);
	      this.render();
	    },
	    events: {
	      'submit form.new_comment': 'postComment'
	    },
	    render: function render() {
	      var $comments = this.$('.comments'),
	          view = this;
	      $comments.empty();
	      this.model.comments.each(function (comment) {
	        var item = new CommentView({ model: comment, commentsView: view });
	        $comments.append(item.render().$el);
	      });
	      return this;
	    },
	    postComment: function postComment() {
	      var params = { comment: { body: this.$('textarea.comment').val() } },
	          view = this;
	      $.post('/segments/' + this.model.get('_id') + '/add_comment', params, function (data) {
	        var comment = new Comment(Comment.prototype.parse(data));
	        comment.segment = view.model;
	        view.model.comments.add(comment);
	      });
	      this.$('textarea.comment').val('');
	      return false;
	    }
	  });
	
	  SegmentView = Backbone.View.extend({
	    el: '#segments-show',
	    flagMode: false,
	    initialize: function initialize() {
	      _.bindAll(this, 'render', 'onSelectionChange');
	      this.commentsView = new CommentsView({ model: this.model, segmentView: this });
	      if (!ns.embedded) {
	        var that = this;
	        $(window).on('load', function () {
	          $(window).resize(that.resizeLayout).resize();
	        });
	      }
	      this.showSegment();
	      this.render();
	      this.model.bind('change', this.render);
	    },
	    events: {
	      'click a.editName': 'toggleEditNameForm',
	      'click a.collapseLeft': 'collapseLeft',
	      'click a.expandLeft': 'expandLeft',
	      'click a.ignore_this': 'ignore',
	      'click a.remember': 'remember',
	      'click a.unignore_this': 'unignore',
	      'click a.unremember_this': 'unremember',
	      'click a.show_leaderboard': 'showLeaderboard',
	      'click a.show_all_efforts': 'showAllEfforts',
	      'click a.show_friend_efforts': 'showFriendEfforts',
	      'click a.toggle_hidden_rides': 'toggleHiddenRides',
	      'click .sort_by .rank': 'sortByRank',
	      'click .sort_by .date': 'sortByDate',
	      'change input.toggle_all': 'toggleAll',
	      'click a.enable_flagging': 'toggleFlagging',
	      'click a.disable_flagging': 'toggleFlagging',
	      'click a.flag_segment': 'flag',
	      'click a.compare_efforts': 'compareEfforts',
	      'click a.toggle_details': 'toggleDetails',
	      'click a.flag_remove_checked': 'flagRemoveChecked'
	    },
	    render: function render() {
	      if (rwgps.config.currentUser) {
	        if (this.model.get('is_ignored')) {
	          this.$('p.ignore span.unignore').show();
	          this.$('p.ignore a.ignore_this').hide();
	          this.$('h1').addClass('bumpup');
	          this.$('p.remember a.remember').hide();
	          this.$('p.remember span.unremember').hide();
	        } else if (this.model.get('is_remembered')) {
	          this.$('p.remember a.remember').hide();
	          this.$('p.remember span.unremember').show();
	          this.$('p.ignore span.unignore').hide();
	          this.$('p.ignore a.ignore_this').hide();
	          this.$('h1').removeClass('bumpup');
	        } else {
	          this.$('p.remember a.remember').show();
	          this.$('p.remember span.unremember').hide();
	          this.$('p.ignore span.unignore').hide();
	          this.$('p.ignore a.ignore_this').show();
	          this.$('h1').addClass('bumpup');
	        }
	      }
	      // render votes
	      var upvotes = this.model.get('remembered_count'),
	          downvotes = this.model.get('ignored_count'),
	          voteStr = [];
	      if (upvotes > 0) voteStr.push("+" + upvotes);
	      if (downvotes > 0) voteStr.push("-" + downvotes);
	      if (voteStr.length > 0) {
	        this.$('p.votes').html("Popularity: " + voteStr.join('/'));
	      } else {
	        this.$('p.votes').empty();
	      }
	
	      if (this.model.get('is_private')) this.showAllEfforts();else this.showLeaderboard();
	    },
	    renderMatches: function renderMatches(comparator) {
	      var matches = this.matches;
	      var $tbody = this.$('table.leaderboard tbody.matches').empty();
	      this.$('input.toggle_all').attr('checked', false);
	      if (comparator) matches = matches.sort(comparator);
	      this.matchRows = [];
	      _.each(matches, function (match) {
	        var row = new SegmentMatchView({ model: match, rank: match.rank, segmentView: this });
	        row.bind('effort_select:change', this.onSelectionChange);
	        this.matchRows.push(row);
	        $tbody.append(row.render().$el);
	      }, this);
	      $tbody.find('tr:odd').addClass('a');
	      //2x toggle ensures changing match views (all, best, etc) won't clear cur flagging UI
	      this.toggleFlagging();
	      this.toggleFlagging();
	      this.onSelectionChange();
	    },
	    toggleEditNameForm: function toggleEditNameForm() {
	      this.$('.editNameForm').toggle();
	    },
	    getConfirmationIfCompareEffortsActive: function getConfirmationIfCompareEffortsActive() {
	      if (!this.compareEffortsView) return true;
	      if (confirm('The link you clicked will populate the map, but the effort comparison is using it currently. Click OK to close the effort comparison')) {
	        this.compareEffortsView.cancelCompareEfforts();
	        delete this.compareEffortsView;
	        return true;
	      } else return false;
	    },
	    onSelectionChange: function onSelectionChange() {},
	    initGraphAndMap: function initGraphAndMap() {
	      Routes.activeMap = new rwgps.Map(ns.mapOpts);
	      // init elevation profile
	      ns.graph = new SampleGraph({ canvasId: 'graph', displayLightControls: true });
	      Routes.sampleGraph = ns.graph;
	      ns.graph.resize($('#elevation_profile').width(), $('#elevation_profile').height());
	    },
	    showSegment: function showSegment() {
	      // init sample graph and map if its not already rocking
	      if (!ns.graph && !Routes.activeMap) {
	        this.initGraphAndMap();
	      }
	      var segment = this.model,
	          view = this;
	      var afterMapInit = function afterMapInit() {
	        var route = new rwgps.Route({ track_points: segment.get('points') });
	        Routes.activeMap.loadRouteForView(route, function () {
	          var mc = rwgps.activeNs.graph.metricsCalculator();
	          mc.calculateUCIClimbRating();
	          mc.calculateFietsIndex();
	          var metrics = mc.metrics();
	          view.$('.segment_metrics table').show();
	          view.$('.segment_metrics .distance').text(rwgps.LabelMaker.longLabel(metrics.distance, true));
	          view.$('.segment_metrics .ele_gain').text('+' + rwgps.LabelMaker.shortLabel(metrics.ele_gain, true));
	          if (metrics.isClimb) {
	            view.$('.segment_metrics .show_if_climb').show();
	            view.$('.segment_metrics .avg_grade').text(metrics.grade.avg.toFixed(1) + '%');
	            view.$('.segment_metrics .climb_category').text(metrics.uciCategory);
	            view.$('.segment_metrics .fiets_index').text(metrics.fietsIndex.toFixed(2));
	          }
	        });
	        Routes.activeMap.resize();
	        _.defer(function () {
	          Routes.activeMap.recenterMap();
	        });
	      };
	      if (ns.embedded) rwgps.activeNs.doWithMap(afterMapInit);else rwgps.Events.bind('map:initialized', afterMapInit);
	    },
	    collapseLeft: function collapseLeft() {
	      $('#expandCollapseLeft').removeClass('collapseLeft').addClass('expandLeft').html('&gt;&gt;');
	      $('#leftPane').hide();
	      $('#rightPane').width('100%');
	      $(window).resize();
	      Routes.activeMap.recenterMap();
	    },
	    expandLeft: function expandLeft() {
	      $('#expandCollapseLeft').removeClass('expandLeft').addClass('collapseLeft').html('&lt;&lt;');
	      $('#leftPane').show();
	      $('#rightPane').width($('#routeContainer').innerWidth() - $('#leftPane').outerWidth() - 1);
	      $(window).resize();
	      if (Routes.activeMap) Routes.activeMap.resize();
	    },
	    ignore: function ignore() {
	      customConfirm("If you ignore this, we'll delete all your matches, and you will not match on it in the future. Are you sure? \n\n(Note: it will take a minute before your matches are removed)", _.bind(function () {
	        this.model.ignore();
	        $.jGrowl("Segment ignored, we won't match you on it on future rides.");
	      }, this));
	    },
	    remember: function remember() {
	      this.model.remember();
	      $.jGrowl("Segment remembered, find it on your profile and it will stand out on your rides.");
	    },
	    unignore: function unignore() {
	      this.model.unignore();
	      $.jGrowl("Segment no longer ignored.");
	    },
	    unremember: function unremember() {
	      this.model.unremember();
	      $.jGrowl("Segment no longer remembered");
	    },
	    showUserEfforts: function showUserEfforts(userId) {
	      var view = this;
	      $.get('/segments/' + this.model.get('_id') + '/matches.json', { user: userId }, function (data) {
	        view.matches = view.buildMatches(data);
	        view.showing = 'effortsByUser';
	        view.renderMatches();
	        view.$('.show_leaderboard').show();
	        view.$('.show_not_leaderboard').hide();
	      });
	    },
	    showLeaderboard: function showLeaderboard() {
	      var view = this;
	      $.get('/segments/' + this.model.get('_id') + '/matches.json', function (data) {
	        view.matches = view.buildMatches(data);
	        view.showing = 'leaderboard';
	        view.renderMatches();
	        view.$('.show_not_leaderboard').show();
	        view.$('.show_leaderboard').hide();
	      });
	    },
	    showAllEfforts: function showAllEfforts() {
	      var view = this;
	      $.get('/segments/' + this.model.get('_id') + '/matches.json', { all: true }, function (data) {
	        view.matches = view.buildMatches(data);
	        view.showing = 'all';
	        view.renderMatches();
	        view.$('.show_not_leaderboard').hide();
	        view.$('.show_leaderboard').show();
	      });
	    },
	    showFriendEfforts: function showFriendEfforts() {
	      var view = this;
	      $.get('/segments/' + this.model.get('_id') + '/matches.json', { friends: true }, function (data) {
	        view.matches = view.buildMatches(data);
	        view.showing = 'friends';
	        view.renderMatches();
	        view.$('.show_not_leaderboard').hide();
	        view.$('.show_leaderboard').show();
	      });
	    },
	
	    buildMatches: function buildMatches(data) {
	      var parsedMatches = _.map(data['segment_matches'], SegmentMatch.prototype.parse);
	
	      _.each(parsedMatches, function (match) {
	        var userId = match.user_as_json.id;
	        match.user_has_comments = rwgps.ns('segments.show').segment.userHasComments[userId];
	      });
	
	      this.segment_matches = new SegmentMatches(parsedMatches);
	
	      //set rank after initial sorting, collection's default comparator is by rank
	      var rank = 1;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.segment_matches.models[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var match = _step.value;
	          match.rank = rank++;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return this.segment_matches.models.slice(0);
	    },
	
	    toggleHiddenRides: function toggleHiddenRides() {
	      this.$('.hidden_rides').toggle();
	    },
	    sortByRank: function sortByRank() {
	      this.sortBy('rank');
	    },
	    sortByDate: function sortByDate() {
	      this.sortBy('date');
	    },
	    toggleAll: function toggleAll(e) {
	      var $checkboxes = this.$('tbody.matches input[type=checkbox]');
	      if ($(e.currentTarget).is(':checked')) {
	        $checkboxes.attr('checked', true).change();
	      } else {
	        $checkboxes.attr('checked', false).change();
	      }
	    },
	    sortBy: function sortBy(type) {
	      var active = type,
	          inactive = type == 'date' ? 'rank' : 'date',
	          matches = this.segment_matches;
	      if (this.$('.sort_by .' + active).hasClass('active')) return;
	      this.$('.sort_by').find('.' + inactive).removeClass('active').addClass('inactive').end().find('.' + active).removeClass('inactive').addClass('active').end();
	      this.renderMatches(matches[active + 'Comparator']);
	    },
	    toggleFlagging: function toggleFlagging() {
	      if (this.flagMode) {
	        this.$('.flagging').hide();
	      } else {
	        this.$('.flagging').show();
	      }
	      this.$('.enable_flagging').toggle();
	      this.$('.disable_flagging').toggle();
	      this.flagMode = !this.flagMode;
	    },
	    resizeLayout: function resizeLayout() {
	      if (ns.embedded) return;
	
	      // get left and right panes the full height
	      var availableHeight = $(window).height() - $('.globalNav').offset().top - $('.globalNav').outerHeight();
	      $('#routeContainer,#leftPane,#rightPane').height(availableHeight);
	      // position expand/collapse button
	      var left = $('#rightPane').offset().left;
	      $('#expandCollapseLeft').offset({ left: left });
	      if (Routes.activeMap) Routes.activeMap.resize();
	    },
	    flag: function flag() {
	      this.model.flag();
	      $('.segment-flagging').hide();
	    },
	    selectedEfforts: function selectedEfforts() {
	      return _.map(_.filter(this.matchRows, function (row) {
	        return row.selected;
	      }), function (row) {
	        return row.model;
	      });
	    },
	    compareEfforts: function compareEfforts() {
	      var selectedEfforts = this.selectedEfforts(),
	          promises = _.map(selectedEfforts, function (effort) {
	        return effort.route();
	      }),
	          view = this;
	      if (selectedEfforts.length == 0) {
	        customAlert(T.t('select_to_compare'));
	        return;
	      }
	      if (this.displayingFullTrip) {
	        this.$('table.leaderboard tr.selected a.show').click();
	        setTimeout(_.bind(this.compareEfforts, this), 200);
	        return;
	      }
	      $.when.apply($, promises).done(function () {
	        if (view.compareEffortsView) view.compareEffortsView.cancelCompareEfforts();
	        view.compareEffortsView = new CompareEffortsView({ efforts: selectedEfforts, isPrivate: view.model.get('is_private') });
	        view.compareEffortsView.bind('closed', function () {
	          delete view.compareEffortsView;
	        });
	      });
	    },
	    flagRemoveChecked: function flagRemoveChecked() {
	      _.each(this.selectedEfforts(), function (effort) {
	        effort.flagRemove();
	      });
	    },
	    toggleDetails: function toggleDetails() {
	      if (this.selectedEfforts().length == 0) {
	        customAlert(T.t('select_to_toggle'));
	        return;
	      }
	      if (!this.displayingDetails) {
	        this.$('tr.details').show();
	        this.displayingDetails = true;
	      } else {
	        this.$('tr.details').hide();
	        this.displayingDetails = false;
	      }
	    }
	  });
	
	  CompareEffortsView = Backbone.View.extend({
	    el: '#compare_efforts_container',
	    template: _.template($('#compareEffortsTemplate').html()),
	    initialize: function initialize() {
	      _.bindAll(this, 'sliceSelected', 'sliceOver', 'sliceOut', 'onResize', 'cancelCompareEfforts');
	      this.efforts = this.options.efforts;
	      this.splitQuarter();
	      // the graph fires a nice throttled resize that we'll listen to for updating our stuff
	      ns.graph.bind('resize', this.onResize);
	      rwgps.Events.bind('segment:unload', this.cancelCompareEfforts);
	    },
	    events: {
	      'click .split .none': 'splitNone',
	      'click .split .quarter': 'splitQuarter',
	      'click .split .third': 'splitThird',
	      'click .split .halve': 'splitHalve',
	      'click .split .custom': 'splitCustom',
	      'click .perform_custom_split': 'performCustomSplit',
	      'click .cancel_compare_efforts': 'cancelCompareEfforts',
	      'click .stage_race': 'stageRace',
	      'click .hide_racing_controls': 'unstageRace',
	      'click #play_pause_btn': 'playPause',
	      'click #stop_btn': 'stopPlayback',
	      'click .clear_selection': 'clearSelectedSlice',
	      'change .pause_on_first_finish': 'updatePauseOnAnyFinish'
	    },
	    cancelCompareEfforts: function cancelCompareEfforts() {
	      ns.graph.enableDragBehavior();
	      this.undelegateEvents();
	      this.unstageRace();
	      this.clearSelectedSlice(true);
	      this.$('.compare_efforts_content').html('');
	      ns.graph.partition(null);
	      this.$el.hide();
	      this.trigger('closed');
	    },
	    initPlayheadAndMarkers: function initPlayheadAndMarkers() {
	      var mtp = this.multiTrackPlayhead = new SampleGraph.MultiTrackPlayhead(ns.graph),
	          iconId;
	      _.each(this.efforts, function (effort) {
	        if (_.isNumber(this._selectedSliceI)) {
	          iconId = mtp.addData(effort.get('partition').slice(this._selectedSliceI).dataObj());
	        } else {
	          iconId = mtp.addData(effort.get('data'));
	        }
	        effort.trigger('racingicon:change', iconId % 10 + 1);
	      }, this);
	      mtp.pauseOnAnyFinish(this.$('.pause_on_first_finish').is(':checked'));
	      this.setPlaybackSpeed(this.playbackSpeedSliderValueToSpeed($('#playback_speed_slider').slider('value')) / 20);
	    },
	    updatePauseOnAnyFinish: function updatePauseOnAnyFinish(e) {
	      if (this.multiTrackPlayhead) {
	        this.multiTrackPlayhead.pauseOnAnyFinish($(e.currentTarget).is(':checked'));
	      }
	    },
	    setPlaybackPercentage: function setPlaybackPercentage(pct) {
	      this.pause();
	      this.multiTrackPlayhead.setPlaybackPercentage(pct);
	    },
	    setPlaybackSpeed: function setPlaybackSpeed(speed) {
	      if (!this.multiTrackPlayhead) this.initPlayheadAndMarkers();
	      var mtp = this.multiTrackPlayhead;
	      mtp.playbackSpeed = speed;
	    },
	    playPause: function playPause(e) {
	      var $a = $(e.currentTarget);
	      if (!$a.hasClass('playing')) {
	        this.play();
	      } else {
	        this.pause();
	      }
	    },
	    play: function play() {
	      if (!this.multiTrackPlayhead) this.initPlayheadAndMarkers();
	      var mtp = this.multiTrackPlayhead;
	      $('#play_pause_btn').addClass('playing');
	      mtp.play();
	      ns.graph.unbindMouseInteractions();
	    },
	    pause: function pause() {
	      if (!this.multiTrackPlayhead) this.initPlayheadAndMarkers();
	      var mtp = this.multiTrackPlayhead;
	      $('#play_pause_btn').removeClass('playing');
	      mtp.pause();
	    },
	    stopPlayback: function stopPlayback() {
	      if (this.multiTrackPlayhead) {
	        this.multiTrackPlayhead.stopPlayback();
	        this.$('#play_pause_btn').removeClass('playing');
	        ns.graph.bindMouseInteractions();
	        $("#elapsed_time_slider").slider('option', 'value', 0);
	        $('#elapsed_time').html(rwgps.LabelMaker.durationLabel(0));
	      }
	    },
	    splitNone: function splitNone() {
	      this.$('.custom_split_options').hide();
	      this.partitionFrac = 1;
	      this.render();
	      this.updateSplitButtons('none');
	    },
	    splitQuarter: function splitQuarter() {
	      this.$('.custom_split_options').hide();
	      this.partitionFrac = 0.25;
	      this.render();
	      this.updateSplitButtons('quarter');
	    },
	    splitThird: function splitThird() {
	      this.$('.custom_split_options').hide();
	      this.partitionFrac = 1.0 / 3;
	      this.render();
	      this.updateSplitButtons('third');
	    },
	    splitHalve: function splitHalve() {
	      this.$('.custom_split_options').hide();
	      this.partitionFrac = 0.5;
	      this.render();
	      this.updateSplitButtons('halve');
	    },
	    splitCustom: function splitCustom() {
	      this.$('.custom_split_options').show();
	      this.updateSplitButtons('custom');
	    },
	    performCustomSplit: function performCustomSplit() {
	      var input = this.$('.custom_split_input').val(),
	          splitDist = parseFloat(input);
	      this.partitionFrac = rwgps.Convert.longToM(splitDist) / ns.graph.metricsCalculator().metrics().distance;
	      this.render();
	      this.$('.custom_split_input').val(input);
	      this.splitCustom();
	    },
	    updateSplitButtons: function updateSplitButtons(depress) {
	      this.$('.split .three_buttons').find('.toggled').removeClass('toggled').end().find('.' + depress).addClass('toggled');
	    },
	    sliceSelected: function sliceSelected(i) {
	      this.alignOnSlice(i, function () {
	        _.each(this.rows, function (row) {
	          row.$slice.addClass('selected');
	        });
	        var graphSlice = ns.graph.partition().slice(i);
	        ns.graph.highlightDataSliceOnMap(graphSlice);
	        ns.graph.identifySegment(graphSlice);
	      });
	      delete this.multiTrackPlayhead;
	      this._selectedSliceI = i;
	      this.$('.clear_selection').css({ visibility: 'visible' });
	    },
	    executeOnNthCall: function executeOnNthCall(n, fn, ctx) {
	      if (!ctx) ctx = this;
	      return function () {
	        n--;
	        if (n == 0) fn.call(ctx);
	      };
	    },
	    alignOnSlice: function alignOnSlice(i, afterAnimationFn) {
	      var rows = [];
	      this.stopPlayback();
	      this.sliceOut();
	      $('.compare_efforts_row .slice:nth-child(' + (i + 1) + ')').each(function () {
	        var $this = $(this);
	        rows.push({
	          $el: $this.parent(),
	          $slice: $this,
	          parentLeft: $this.parent().offset().left - 14, // padding
	          left: $this.offset().left
	        });
	      });
	      var maxLeft = rows[0].left - rows[0].parentLeft;
	      for (var j = 1; j < rows.length; j++) {
	        var adjLeft = rows[j].left - rows[j].parentLeft;
	        if (adjLeft > maxLeft) maxLeft = adjLeft;
	      }
	      var fn = this.executeOnNthCall(rows.length, afterAnimationFn, { rows: rows });
	      $('.compare_efforts_row .slice.selected').removeClass('selected');
	      _.each(rows, function (row) {
	        row.$el.offset({ left: row.$el.offset().left });
	        var speed = Math.abs(maxLeft - row.left);
	        row.$el.animate({ left: '+=' + (maxLeft - row.left) }, speed, fn);
	      });
	    },
	    clearSelectedSlice: function clearSelectedSlice(dontAlign) {
	      if (!_.isNumber(this._selectedSliceI)) return;
	      $('.compare_efforts_row .slice.selected').removeClass('selected');
	      if (dontAlign === true) {
	        ns.graph.unidentifySegment();
	        rwgps.unhighlightPoints();
	      } else {
	        this.alignOnSlice(0, function () {
	          ns.graph.unidentifySegment();
	          rwgps.unhighlightPoints();
	        });
	      }
	      this.$('.clear_selection').css({ visibility: 'hidden' });
	      delete this.multiTrackPlayhead;
	      delete this._selectedSliceI;
	    },
	    sliceOver: function sliceOver(i) {
	      if (_.isNumber(this._selectedSliceI)) return;
	      var graphSlice = ns.graph.partition().slice(i);
	      ns.graph.highlightDataSliceOnMap(graphSlice, true);
	      ns.graph.identifySegment(graphSlice);
	      $('.compare_efforts_row .slice:nth-child(' + (i + 1) + ')').addClass('over');
	    },
	    sliceOut: function sliceOut() {
	      if (_.isNumber(this._selectedSliceI)) return;
	      ns.graph.unidentifySegment();
	      rwgps.unhighlightPoints();
	      $('.compare_efforts_row .slice.over').removeClass('over');
	    },
	    stageRace: function stageRace() {
	      $('a.stage_race').hide();
	      $('#playback_container').show();
	      this.initPlayback();
	      this.pause();
	    },
	    unstageRace: function unstageRace() {
	      this.stopPlayback();
	      this.$('.racingicon').hide();
	      delete this.multiTrackPlayhead;
	      $('a.stage_race').show();
	      $('#playback_speed_label').html('32x');
	      $('#playback_container').hide();
	    },
	    playbackSpeedSliderValues: [1, 1.5, 2, 2.5, 3, 4, 5, 6, 7, 8, 9, 10, 13, 16, 19, 23, 27, 32, 36, 41, 47, 52, 58, 65, 72, 79, 86, 94, 102, 110, 119, 128, 137, 146, 156, 167, 177, 188, 200],
	    playbackSpeedSliderValueToSpeed: function playbackSpeedSliderValueToSpeed(value) {
	      return this.playbackSpeedSliderValues[value];
	    },
	    initPlayback: function initPlayback() {
	      var view = this;
	      if (!$('#playback_container').is(':visible')) return;
	      $("#elapsed_time_slider").slider({
	        min: 0,
	        max: 100,
	        slide: function slide(event, ui) {
	          view.setPlaybackPercentage(ui.value);
	        }
	      });
	      $("#playback_speed_slider").slider({
	        min: 0,
	        max: view.playbackSpeedSliderValues.length - 1,
	        value: 17,
	        slide: function slide(event, ui) {
	          var val = view.playbackSpeedSliderValueToSpeed(ui.value);
	          $('#playback_speed_label').html(val + 'x');
	          view.setPlaybackSpeed(val / 20);
	        }
	      });
	    },
	    onResize: function onResize() {
	      var maxWidth = this.$el.width() - 50,
	          view = this;
	      _.each(this.rowViews, function (row) {
	        var effort = row.model,
	            partition = effort.get('partition'),
	            i = 0;
	        row.$el.find('.slice').each(function () {
	          var width = partition.slice(i).metrics().duration / view.longestDuration * maxWidth;
	          $(this).width(width).find('.bar').width(width - 2);
	          i++;
	        });
	      }, this);
	      if (this._selectedSliceI) {
	        this.sliceSelected(this._selectedSliceI);
	      }
	    },
	    render: function render() {
	      ns.graph.disableDragBehavior();
	      if (this.partitionFrac == 1) ns.graph.enableDragBehavior();
	
	      this.stopPlayback();
	      delete this.multiTrackPlayhead;
	      this.clearSelectedSlice(true);
	      this.$('.compare_efforts_content').html(this.template());
	      this.$el.show();
	      if (!this.$('#playback_container').is(':visible')) {
	        $('a.stage_race').show();
	      }
	      var $list = this.$el.find('ul.compare_efforts_rows');
	      // figure out which of these efforts is the longest and build a ratio from that for width of each slice bar
	      var longestDuration = this.longestDuration = _.reduce(this.efforts, function (memo, effort) {
	        var duration = effort.get('data').metrics().duration;
	        if (duration > memo) return duration;else return memo;
	      }, 0);
	      // [[min,max], [min,max]] <- if there are two slices
	      var sliceDurationRanges = [];
	      _.each(this.efforts, function (effort) {
	        effort.set('partition', effort.get('data').partitionByDistanceFraction(this.partitionFrac));
	        var slices = effort.get('partition').slices();
	        for (var i = 0; i < slices.length; i++) {
	          var duration = slices[i].metrics().duration;
	          if (!sliceDurationRanges[i]) sliceDurationRanges[i] = [duration, duration];else {
	            if (sliceDurationRanges[i][0] > duration) sliceDurationRanges[i][0] = duration;
	            if (sliceDurationRanges[i][1] < duration) sliceDurationRanges[i][1] = duration;
	          }
	        }
	      }, this);
	      // load partition into sample graph
	      ns.graph.partitionByDistanceFraction(this.partitionFrac);
	      var maxWidth = this.$el.width() - 50;
	      this.rowViews = [];
	      _.each(this.efforts, function (effort) {
	        var partition = effort.get('partition'),
	            row = new CompareEffortsRowView({ model: effort, partition: partition, longestDuration: longestDuration, sliceDurationRanges: sliceDurationRanges, isPrivate: this.options.isPrivate });
	        this.rowViews.push(row);
	        row.bind('slice:selected', this.sliceSelected);
	        row.bind('slice:over', this.sliceOver);
	        row.bind('slice:out', this.sliceOut);
	        $list.append(row.render().$el);
	        _.defer(function () {
	          var i = 0;
	          row.$el.find('.slice').each(function () {
	            var width = partition.slice(i).metrics().duration / longestDuration * maxWidth;
	            $(this).width(width).find('.bar').width(width - 2);
	            i++;
	          });
	        });
	      }, this);
	      return this;
	    }
	  });
	
	  CompareEffortsRowView = Backbone.View.extend({
	    tagName: 'li',
	    className: 'compare_efforts_row',
	    template: _.template($('#compareEffortsRowTemplate').html()),
	    initialize: function initialize() {
	      _.bindAll(this, 'sliceOver', 'sliceOut', 'racingIconChange');
	      this.partition = this.options.partition;
	      this.model.bind('racingicon:change', this.racingIconChange);
	    },
	    events: {
	      'click .bar': 'sliceSelected'
	    },
	    racingIconChange: function racingIconChange(iconId) {
	      this.$('.racingicon').attr('src', '/images/icons/racers/' + iconId + '.png').show();
	    },
	    sliceSelected: function sliceSelected(e) {
	      // figure out which slice it was, 0-based index
	      this.trigger('slice:selected', $(e.target).closest('.slice').prevAll().size());
	    },
	    sliceOver: function sliceOver(e) {
	      this.trigger('slice:over', $(e.target).closest('.slice').prevAll().size());
	    },
	    sliceOut: function sliceOut() {
	      this.trigger('slice:out');
	    },
	    render: function render() {
	      var tmplData = this.model.toJSON();
	      tmplData.partition = this.partition;
	      tmplData.metric = rwgps.LabelMaker.metric;
	      tmplData.longestDuration = this.options.longestDuration;
	      tmplData.sliceDurationRanges = this.options.sliceDurationRanges;
	      tmplData.duration = this.model.get('duration');
	      tmplData.isPrivate = this.options.isPrivate;
	      this.$el.html(this.template(tmplData));
	      this.$el.find('.bar').hoverIntent(this.sliceOver, this.sliceOut);
	      return this;
	    }
	  });
	
	  SegmentMatchView = Backbone.View.extend({
	    tagName: 'tr',
	    template: _.template($('#segmentMatchTemplate').html()),
	    detailsTemplate: _.template($('#detailedMetricsTemplate').html()),
	    initialize: function initialize() {
	      _.bindAll(this, 'displayRoute', 'renderDetailsFromRoute');
	    },
	    events: {
	      'click a.show': 'show',
	      'change .check': 'toggleDetails',
	      'click a.show_trip': 'showTrip',
	      'click a.show_user_efforts': 'showUserEfforts',
	      'click a.comments': 'highlightUserComments',
	      'click a.flag_match': 'flag',
	      'click a.flag_remove_match': 'flagRemove'
	    },
	    render: function render() {
	      var tmplData = this.model.toJSON();
	      tmplData.rank = this.options.rank;
	      tmplData.showingEffortsByUser = this.options.segmentView.showing == 'effortsByUser';
	      this.$el.html(this.template(tmplData));
	      return this;
	    },
	    renderDetails: function renderDetails() {
	      this.hideDetails();
	      var mc = this.data.metricsCalculator(),
	          alt = this.$el.hasClass('a'),
	          $detailsRow = $(this.detailsTemplate({ mc: mc, metric: rwgps.LabelMaker.metric })).hide();
	      this.$el.after($detailsRow);
	      if (alt) $detailsRow.addClass('a');
	    },
	    displayRoute: function displayRoute(route) {
	      this.options.segmentView.displayingFullTrip = false;
	      var view = this;
	      Routes.activeMap.callWhenReady(function () {
	        Routes.activeMap.removeRoute(Routes.activeMap.activeRoute);
	        Routes.activeMap.loadRouteForView(route);
	        Routes.activeMap.resize();
	        Routes.activeMap.recenterMap();
	        view.showDetails();
	      });
	    },
	    renderDetailsFromRoute: function renderDetailsFromRoute(route) {
	      // we'll have to get this from somewhere else if we aren't always display it on the map
	      this.data = new rwgps.Data(route.trackPoints());
	      this.renderDetails();
	    },
	    showAsSelected: function showAsSelected() {
	      this.$el.closest('tbody').find('.check:checked').attr('checked', false).change();
	      this.$('.check').attr('checked', true);
	      this.trigger('effort_select:change');
	      // update UI to show the selected route
	      this.$el.closest('table').find('tr.selected').removeClass('selected').end().end().addClass('selected');
	    },
	    show: function show() {
	      if (this.options.segmentView.getConfirmationIfCompareEffortsActive()) {
	        this.showAsSelected();
	        this.model.route().done(this.displayRoute);
	      }
	    },
	    toggleDetails: function toggleDetails(e) {
	      $('.flag_remove_checked').show();
	      this.trigger('effort_select:change');
	      if ($(e.target).is(':checked')) {
	        this.showDetails();
	      } else {
	        $('input.toggle_all').attr('checked', false);
	        this.selected = false;
	        this.hideDetails();
	      }
	    },
	    showDetails: function showDetails() {
	      this.selected = true;
	      this.model.route().done(this.renderDetailsFromRoute);
	    },
	    hideDetails: function hideDetails() {
	      var $details = this.$el.next();
	      if ($details.hasClass('details')) $details.remove();
	      this.$el.find('.showDetails').show().end().find('.hideDetails').hide();
	    },
	    showTrip: function showTrip() {
	      if (this.options.segmentView.getConfirmationIfCompareEffortsActive()) {
	        this.showAsSelected();
	        var view = this;
	        this.model.fullTrip().done(function () {
	          view.displayRoute.apply(view, arguments);
	          view.options.segmentView.displayingFullTrip = true;
	        });
	      }
	    },
	    showUserEfforts: function showUserEfforts() {
	      this.options.segmentView.showUserEfforts(this.model.get('user_as_json').id);
	    },
	    highlightUserComments: function highlightUserComments() {
	      var id = this.model.get('user_as_json').id,
	          segView = this.options.segmentView;
	      $('.comment.highlighted').removeClass('highlighted');
	      if (segView.lastHighlightedUser != id) {
	        segView.commentsView.trigger('user:highlight_comments:' + id);
	        $('#leftPane').scrollTo('.comment.highlighted:first');
	        segView.lastHighlightedUser = id;
	      } else {
	        delete segView.lastHighlightedUser;
	      }
	    },
	    flag: function flag() {
	      this.model.flag();
	      this.$el.find('.flagging').hide();
	    },
	    flagRemove: function flagRemove() {
	      this.model.flagRemove();
	      this.$el.find('.flagging').hide();
	    }
	  });
	
	  ns.init = function (opts) {
	    if (opts && opts.embedded) ns.embedded = true;
	    ns.finalTimeField = ns.segmentJson.final_time_field;
	    var segment = ns.segment = new Segment(ns.segmentJson);
	    new SegmentView({ model: segment });
	  };
	});

/***/ })

});


// WEBPACK FOOTER //
// segments-show-0ce60aa946da099bc393-bundle.js